import type { IconSvgObject } from './types';

const PocketIcon: IconSvgObject = [
  ["path", { d: "M3 11V10C3 7.17157 3 5.75736 3.87868 4.87868C4.75736 4 6.17157 4 9 4H15C17.8284 4 19.2426 4 20.1213 4.87868C21 5.75736 21 7.17157 21 10V11C21 15.9706 16.9706 20 12 20C7.02944 20 3 15.9706 3 11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.5 10L11.1464 12.6464C11.3728 12.8728 11.6799 13 12 13C12.3201 13 12.6272 12.8728 12.8536 12.6464L15.5 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PocketIcon;
